import PageHeading from "components/PageHeading";
import React, { useState, useEffect } from "react";
import Facebook from "../components/facebook";
import Instagram from "../components/instagram";
import Jeebly from "../components/jeebly";
import Quiqup from "../components/quiqup";
import Telr from "../components/telr";
import Whatsapp from "../components/whatsapp";
import { useTranslation } from "react-i18next";
import Messenger from "../components/messenger";
import { UTILS } from "utils";
import { useGetSettingsMutation } from "redux/settings/settingsSlice";
import { Spin } from "antd";
import Talabat from "../components/talabat";
import Yandex from "../components/yandex";
import Checkout from "../components/checkout";
import AppContainer from "components/ui/AppContainer";
import AppIntegrationCard from "components/ui/AppIntegrationCard";
import AppHeading2 from "components/ui/AppHeading2.jsx";
const Integrations = () => {
  const [getSettings, { isLoading }] = useGetSettingsMutation();

  const [shopUrl, setShopUrl] = useState("");
  const { t } = useTranslation();
  const fetchSettings = async () => {
    const userDetail = UTILS.getCurrentUser();
    const obj = {
      brandId: userDetail.brandId,
    };
    const data = await getSettings(obj).unwrap();

    if (data?.success === 1 && data?.data?.setting) {
      const userDetail = await UTILS.getCurrentUser();
      let url = `${userDetail.storeFrontURL}${data?.data?.setting?.temporaryDomainName}`;
      setShopUrl(url);
    }
  };


  useEffect(() => {
    fetchSettings();
  }, []);

  const socialIntegractions=[
    {
      title:'Instagram',
      description:t('Let customers quickly place their orders directly from your business Instagram profile and Stories.'),
      icon:'insta',
      url:shopUrl,
    },
    {
      title:'Facebook',
      description:'Now you can add a Shop now link on your business Facebook page that goes straight to your ordering menu!',
      icon:'facebook',
      url:shopUrl,
    },
    {
      title:'Whatsapp',
      description:'Use WhatsApp Business to invite customers to check your menu on Resthero and place their orders with a few clicks.!',
      icon:'whatsapp',
      url:shopUrl,
    },
    {
      title:'Messenger',
      description:'Use Messenger to invite customers to check your menu on Resthero and place their orders with a few clicks.!',
      icon:'messenger',
      url:shopUrl,
    },

]

const deliveryIntegractions=[
    {
      title:'Talabat',
      description:"Don't have delivery? We covered you by integrating Talabat. While Accepting an order select Talabat. Send Email to ",
      icon:'talabat',
      url:'',
      link:'info@resthero.io'
    },
    {
      title:'Yandex',
      description:"Don't have delivery? We covered you by integrating Talabat. While Accepting an order select Yandex. Send Email to ",
      icon:'yandex',
      url:'',
      link:'info@resthero.io'
    },
    {
      title:'Quiqup',
      description:"Don't have delivery? We covered you by integrating Talabat. While Accepting an order select Quiqup. Send Email to ",
      icon: "quiqup",
      iconImage: "/images/quiqup.png",
      url:'',
      link:'info@resthero.io'
    },
    {
      title:'Jeebly',
      description:"Don't have delivery? We covered you by integrating Talabat. While Accepting an order select Jeebly. Send Email to ",
      icon: "jeebly",
      iconImage: "/images/jeebly.png",
      url:'',
      link:'info@resthero.io'
    },

]

const paymentIntegractions=[
  {
      title:'Telr Secure Payment',
      description:"Now get payments directly into your account by integrating Telr. Send Email to ",
      icon: "telr",
      iconImage: "/images/telr.png",
      url:'',
      link:'info@resthero.io'
    },
    // {
    //   title:'Checkout Online Payment',
    //   description:"Now get payments directly into your account by integrating Checkout. Send Email to ",
    //   icon:'yandex',
    //   url:'',
    //   link:'info@resthero.io'
    // },
]

  return (
    <AppContainer title={t("Integrations")} subTitle={t("Increase sales and get more exposure by connecting RestHero to your social media channels and other partners.",{company: process.env.REACT_APP_COMPANY_NAME,})} loading={isLoading}>
          <AppHeading2>{t("Social Integrations")}</AppHeading2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-2 mb-5">
            {socialIntegractions.map(social=><AppIntegrationCard title={social.title} description={social.description} icon={social.icon}/>)}
          </div>
          <AppHeading2 className="mt-5">{t("Delivery Integrations")}</AppHeading2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-2 mb-5">
            {deliveryIntegractions.map((delivery) => (
              <AppIntegrationCard
                key={delivery.title}
                title={delivery.title}
                description={delivery.description}
                icon={delivery.icon}
                iconImage={delivery.iconImage}
                link={delivery.link}
              />
            ))}
          </div>

          <AppHeading2 className="mt-5">{t("Payment Integrations")}</AppHeading2>
           <div className="grid grid-cols-1 md:grid-cols-2 gap-5 pt-2 mb-5">
            {paymentIntegractions.map((payment) => (
              <AppIntegrationCard
                key={payment.title}
                title={payment.title}
                description={payment.description}
                icon={payment.icon}
                iconImage={payment.iconImage}
                link={payment.link}
              />
            ))}
          </div>

    </AppContainer>
  );
};
export default Integrations;
